import {
  AppDispatch as CommonAppDispatch,
  RootState as CommonRootState,
  createAppStore,
} from '@lumora/common';

import { webStorageAdapter } from './storageAdapter';

// Create the web store using the factory with no persistence
const { store } = createAppStore({
  storageAdapter: webStorageAdapter,
  persistAuth: false,
  persistGoals: false,
  persistPortfolio: false,
  persistUserPreferences: false,
});

export { store };
export type RootState = CommonRootState;
export type AppDispatch = CommonAppDispatch;
